module.exports = __webpack_public_path__ + "img/erlend-simensen-l.b10c6a95.jpg";